/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {CreateProductAccessTermRequest} from '../models/CreateProductAccessTermRequest';
import type {Error} from '../models/Error';
import type {ProductSubscriptionPage} from '../models/ProductSubscriptionPage';
import type {ProductSubscriptionSearchRequest} from '../models/ProductSubscriptionSearchRequest';

export interface CreateAccountProductAccessTerm$Request {
    accountId: number;
    createProductAccessTermRequest: CreateProductAccessTermRequest;
}

export interface CreateAccountProductAccessTerm$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const createAccountProductAccessTermRequest = createAction<PayloadData<void, CreateAccountProductAccessTerm$Request>>('ACCOUNT_PRODUCT_SUBSCRIPTIONS__CREATE_ACCOUNT_PRODUCT_ACCESS_TERM__REQUEST');
export const createAccountProductAccessTermSuccess = createAction<PayloadData<void, CreateAccountProductAccessTerm$Request>>('ACCOUNT_PRODUCT_SUBSCRIPTIONS__CREATE_ACCOUNT_PRODUCT_ACCESS_TERM__SUCCESS');
export const createAccountProductAccessTermFailure = createAction<PayloadData<Error, CreateAccountProductAccessTerm$Request, true>>('ACCOUNT_PRODUCT_SUBSCRIPTIONS__CREATE_ACCOUNT_PRODUCT_ACCESS_TERM__FAILURE');

export const createAccountProductAccessTermActions = [
    createAccountProductAccessTermRequest,
    createAccountProductAccessTermSuccess,
    createAccountProductAccessTermFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {CreateProductAccessTermRequest} meta.createProductAccessTermRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const createAccountProductAccessTerm = (meta: CreateAccountProductAccessTerm$Request, config?: CreateAccountProductAccessTerm$Config) => {
    return {
        CALL_API: {
            types: createAccountProductAccessTermActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/accounts/${meta.accountId}/product-access-terms`,
            TRANSPORT_REQUEST_BODY: meta.createProductAccessTermRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface SearchAccountProductSubscriptions$Request {
    accountId: number;
    productSubscriptionSearchRequest: ProductSubscriptionSearchRequest;
}

export interface SearchAccountProductSubscriptions$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const searchAccountProductSubscriptionsRequest = createAction<PayloadData<void, SearchAccountProductSubscriptions$Request>>('ACCOUNT_PRODUCT_SUBSCRIPTIONS__SEARCH_ACCOUNT_PRODUCT_SUBSCRIPTIONS__REQUEST');
export const searchAccountProductSubscriptionsSuccess = createAction<PayloadData<ProductSubscriptionPage, SearchAccountProductSubscriptions$Request>>('ACCOUNT_PRODUCT_SUBSCRIPTIONS__SEARCH_ACCOUNT_PRODUCT_SUBSCRIPTIONS__SUCCESS');
export const searchAccountProductSubscriptionsFailure = createAction<PayloadData<Error, SearchAccountProductSubscriptions$Request, true>>('ACCOUNT_PRODUCT_SUBSCRIPTIONS__SEARCH_ACCOUNT_PRODUCT_SUBSCRIPTIONS__FAILURE');

export const searchAccountProductSubscriptionsActions = [
    searchAccountProductSubscriptionsRequest,
    searchAccountProductSubscriptionsSuccess,
    searchAccountProductSubscriptionsFailure
] as const;

/**
 * @param {number} meta.accountId
 * @param {ProductSubscriptionSearchRequest} meta.productSubscriptionSearchRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const searchAccountProductSubscriptions = (meta: SearchAccountProductSubscriptions$Request, config?: SearchAccountProductSubscriptions$Config) => {
    return {
        CALL_API: {
            types: searchAccountProductSubscriptionsActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/accounts/${meta.accountId}/product-subscriptions`,
            TRANSPORT_REQUEST_BODY: meta.productSubscriptionSearchRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

